import { Uuid, getUuid } from '@sibe/utilities/common';
import type { HsCamera } from '../objects/cameras/camera.class';
import type { HsObject3D } from '../objects/common/object-3d.class';
import type { HsRenderSorterType } from '../types/render-sorter-type.type';
import type { HsLayer } from './layer.class';

export class HsRenderSorter<T extends HsObject3D, S extends HsCamera, L extends HsLayer> {
  public readonly uuid: Uuid = getUuid();

  constructor(public sort: HsRenderSorterType<T, S, L>) {}
}
